import { LicenseManager } from '../../managers/License.manager';
import { Title } from '@angular/platform-browser';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Router } from '@angular/router';

export interface ISalesReportDetailsDialogModel {
  licenseManager: LicenseManager;
  salesData: any[];
}

@Component({
  selector: 'sales-report-details-dialog',
  styleUrls: ['./sales.report.details.dialog.css'],
  templateUrl: './sales.report.details.dialog.html'
})
export class SalesReportDetailsDialog extends DialogComponent<ISalesReportDetailsDialogModel, boolean> implements ISalesReportDetailsDialogModel, OnInit, OnDestroy {

  licenseManager: LicenseManager;
  private originalTitle: string;

  salesData: any[];

  constructor(dialogService: DialogService, private titleService: Title, public router: Router) {
    super(dialogService, router);
  }
  ngOnInit() {
    // this.originalTitle = this.titleService.getTitle();
    // this.titleService.setTitle(this.licenseManager.newEntity.License.Key);
  }

  ngOnDestroy() {
    this.titleService.setTitle(this.originalTitle);
  }

  confirm() {
    this.licenseManager.SaveChanges();

    let saved = this.licenseManager.OnChangesSaveResponse.subscribe(response => {
      saved.unsubscribe();

      if (response.Result)
        this.closeOK();
    })
  }


  closeOK() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.result = true;
    this.close();

  }

}
